/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { ColorsV2 } from 'app/constants/color';
import NoData from 'app/pages/insights/compliance/NoData';
import { calculateMinDate, checkForAssignedChartColor, parseAndFormatDate } from 'app/utils';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-moment';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, TimeScale);

const DashedLineChart = ({ clicked, setClicked, chartData = [], MileStones, time, dates }) => {
  const showMileStone = useSelector(state => state.toggleSidebar.showMileStone);
  const sortedData = [...chartData].sort((a, b) => {
    const idA = parseInt(a.id?.slice(1), 10);
    const idB = parseInt(b.id?.slice(1), 10);
    return idA - idB;
  });

  const chartColors = useSelector(state => state?.userSettings?.settings?.chartColors) || {};

  const getColor = id => {
    return chartColors[id] || checkForAssignedChartColor(id);
  };

  const arrays = sortedData?.map(item => item.dataPoints);
  const sourceArray = sortedData?.map(item => item.name);
  const idArray = sortedData?.map(item => item.id);

  const labels =
    arrays?.length > 0
      ? arrays[0]?.map(dataPoint => {
          const formattedDate = parseAndFormatDate(dataPoint.date);
          return formattedDate;
        })
      : [];

  function generateDatasets(arrays, clicked) {
    const datasets = [];

    for (let i = 0; i < arrays?.length; i++) {
      const label = sourceArray[i];
      const id = idArray[i];
      const chartColor = getColor(id);
      const borderColor = chartColor;
      const backgroundColor = chartColor;
      const pointBackgroundColor = chartColor;
      const pointBorderColor = chartColor;
      const data =
        clicked.length === 0 || clicked.includes(sourceArray[i])
          ? arrays[i]?.map(item => item.spread)
          : '';
      const dataset = {
        label,
        data,
        borderColor,
        backgroundColor,
        pointBackgroundColor,
        pointBorderColor,
        categoryPercentage: 0.5,
        barPercentage: 0.5,
        lineTension: 0,
        fill: true,
        // borderWidth: time <= 12 ? 2 : 2,
        // pointRadius: time <= 12 ? 3 : 2,
        borderWidth: 2,
        pointRadius: 0,
        pointHitRadius: 20,
      };
      datasets.push(dataset);
    }

    return datasets;
  }
  const data = {
    labels,
    datasets: generateDatasets(arrays, clicked),
  };

  const handleClick = (event, elements) => {
    if (elements?.length) {
      const clickedLabel = data.labels[elements[0].index];
      setClicked(prevClicked => {
        if (prevClicked.includes(clickedLabel)) {
          return prevClicked.filter(item => item !== clickedLabel);
        } else {
          return [...prevClicked, clickedLabel];
        }
      });
    }
  };

  const options = {
    // onClick: handleClick, - // Temporarily disabled since isolating an information class doesn't make UX sense at the moment
    responsive: true,
    layout: {
      padding: {
        top: 10,
        bottom: 20,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
      },
      tooltip: {
        callbacks: {
          label(value) {
            const label = value?.dataset?.label || '';
            return `${label}: ${value?.raw?.toFixed()}%`;
          }
        }
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'month',
          displayFormats: {
            month: 'DD MMM YYYY',
          },
        },
        ticks: {
          color: ColorsV2.white,
        },
        // grid: {
        //   color: ColorsV2.white,
        //   borderDash: [5, 5],
        //   drawBorder: false,
        // },
        min: calculateMinDate(time).toDate(),
        max: dates?.endDate || Date.now(),
      },
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          color: ColorsV2.white,
          callback(value) {
            return value + '%';
          },
        },
        // grid: {
        //   color: ColorsV2.white,
        // },
      },
    },
    animation: false,
  };

  if (!chartData) {
    return <NoData />;
  }

  return <Line key={JSON.stringify(MileStones)} data={data} options={options} plugins={[MileStones]} />;
};

export default DashedLineChart;
